export default {
    "name": "LIB_updateInventoryBasic",
    "kind": "HoudiniMutation",
    "hash": "4d10410c2de1544be7a584b5d98d6a53a02ec5696adae3d4e1eb86a54feb7c43",

    "raw": `mutation LIB_updateInventoryBasic($part: InventoryUpdate!, $logMessage: String) {
  part: updateInventory(input: $part, logMessage: $logMessage) {
    innodbInventoryid: id
    storeId
    sku
    tagNumber
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "part": {
                "type": "Inventory",
                "keyRaw": "part(input: $part, logMessage: $logMessage)",

                "selection": {
                    "fields": {
                        "innodbInventoryid": {
                            "type": "UInt",
                            "keyRaw": "innodbInventoryid",
                            "visible": true
                        },

                        "storeId": {
                            "type": "UInt",
                            "keyRaw": "storeId",
                            "visible": true
                        },

                        "sku": {
                            "type": "UInt",
                            "keyRaw": "sku",
                            "visible": true
                        },

                        "tagNumber": {
                            "type": "String",
                            "keyRaw": "tagNumber",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "part": "InventoryUpdate",
            "logMessage": "String"
        },

        "types": {
            "NestedNewInventoryAttachment": {
                "file": "Upload",
                "fileId": "UInt",
                "public": "Boolean",
                "rank": "Int"
            },

            "InventoryAttachmentUpdate": {
                "id": "Int",
                "public": "Boolean",
                "rank": "Int"
            },

            "NestedInventoryAttachmentUpdates": {
                "create": "NestedNewInventoryAttachment",
                "remove": "Int",
                "update": "InventoryAttachmentUpdate"
            },

            "NewCollection": {
                "members": "NewCollectionMember",
                "type": "CollectionTypeEnum"
            },

            "InventoryLocationInput": {
                "locationId": "Int",
                "locationName": "String",
                "permanent": "Boolean",
                "quantity": "Decimal6",
                "rank": "Int"
            },

            "InventoryOptionValueUpdate": {
                "inventoryOptionId": "Int",
                "value": "String"
            },

            "SaleClassReference": {
                "code": "String",
                "id": "Int"
            },

            "NestedNewInventorySerial": {
                "location": "String",
                "number": "String",
                "optionValues": "InventoryOptionValueUpdate"
            },

            "DimensionsInput": {
                "height": "Decimal2",
                "length": "Decimal2",
                "measurementUnit": "DimensionsMeasurementUnit",
                "weight": "Decimal6",
                "weightUnit": "DimensionsWeightUnit",
                "width": "Decimal2"
            },

            "NewInventory": {
                "attachments": "NestedNewInventoryAttachment",
                "bodyStyle": "String",
                "buyPackage": "Int",
                "categoryId": "UInt",
                "collection": "NewCollection",
                "condition": "String",
                "coreClass": "String",
                "coreCost": "Decimal2",
                "coreRequired": "Boolean",
                "coreRequiredToVendor": "Boolean",
                "cost": "Decimal2",
                "daysToReturn": "UInt",
                "daysToReturnCore": "UInt",
                "daysToReturnCoreToVendor": "UInt",
                "daysToReturnToVendor": "UInt",
                "defaultVendorId": "UInt",
                "deplete": "Boolean",
                "description": "String",
                "distributorCorePrice": "Decimal2",
                "distributorPrice": "Decimal2",
                "freezeUntil": "Date",
                "glCategoryId": "UInt",
                "interchangeNumber": "String",
                "inventoryTypeId": "UInt",
                "jobberCorePrice": "Decimal2",
                "jobberPrice": "Decimal2",
                "listPrice": "Decimal2",
                "locations": "InventoryLocationInput",
                "manufacturerId": "Int",
                "maxQuantity": "Decimal6",
                "minQuantity": "Decimal6",
                "modelId": "Int",
                "notes": "String",
                "oemNumber": "String",
                "optionValues": "InventoryOptionValueUpdate",
                "parentManufacturerId": "UInt",
                "parentModelId": "UInt",
                "partNumber": "String",
                "popularityCode": "String",
                "priceGroup": "String",
                "printTag": "Boolean",
                "public": "Boolean",
                "purchaseFactor": "Boolean",
                "quantity": "Decimal6",
                "replenishable": "Boolean",
                "retailCorePrice": "Decimal2",
                "retailPrice": "Decimal2",
                "returnable": "Boolean",
                "returnableToVendor": "Boolean",
                "safetyStockPercent": "Decimal2",
                "saleClass": "SaleClassReference",
                "seasonal": "Boolean",
                "sellPackage": "UInt",
                "sellPriceClassId": "Int",
                "serialized": "Boolean",
                "serials": "NestedNewInventorySerial",
                "shippingDimensions": "DimensionsInput",
                "side": "SideEnum",
                "singleQuantity": "Boolean",
                "sku": "Int",
                "status": "StatusEnum",
                "stockMethod": "StockMethodEnum",
                "stockType": "StockTypeEnum",
                "stockingDays": "Int",
                "storeId": "UInt",
                "subInterchangeNumber": "String",
                "tagNumber": "String",
                "taxable": "Boolean",
                "typeData1": "String",
                "typeData2": "String",
                "typeData3": "String",
                "typeData4": "String",
                "userStatus": "String",
                "vehicleId": "UInt",
                "vehicleMake": "String",
                "vehicleModel": "String",
                "vehicleVin": "String",
                "vehicleYear": "UInt",
                "vendorPopularityCode": "String",
                "vendorProductCode": "String",
                "wholesaleCorePrice": "Decimal2",
                "wholesalePrice": "Decimal2"
            },

            "NewCollectionMember": {
                "costFactor": "Decimal2",
                "existingSkuNumber": "UInt",
                "integral": "Boolean",
                "newInventory": "NewInventory",
                "quantity": "Decimal6"
            },

            "CollectionMemberUpdate": {
                "costFactor": "Decimal2",
                "id": "UInt",
                "integral": "Boolean",
                "quantity": "Decimal6"
            },

            "CollectionMemberListUpdate": {
                "additions": "NewCollectionMember",
                "removals": "UInt",
                "updates": "CollectionMemberUpdate"
            },

            "CollectionUpdate": {
                "members": "CollectionMemberListUpdate",
                "type": "CollectionTypeEnum"
            },

            "NestedNewInventoryLocation": {
                "locationId": "Int",
                "locationName": "String",
                "permanent": "Boolean",
                "quantity": "Decimal6",
                "rank": "Int"
            },

            "NestedInventoryLocationUpdate": {
                "id": "Int",
                "permanent": "Boolean",
                "quantity": "Decimal6",
                "rank": "Int"
            },

            "InventoryLocationUpdates": {
                "create": "NestedNewInventoryLocation",
                "update": "NestedInventoryLocationUpdate"
            },

            "NestedInventorySerialUpdate": {
                "action": "ActionEnum",
                "id": "Int",
                "location": "String",
                "number": "String",
                "optionValues": "InventoryOptionValueUpdate"
            },

            "InventoryUpdate": {
                "attachments": "NestedInventoryAttachmentUpdates",
                "bodyStyle": "String",
                "buyPackage": "Int",
                "categoryId": "Int",
                "collection": "CollectionUpdate",
                "condition": "String",
                "coreClass": "String",
                "coreCost": "Decimal2",
                "coreRequired": "Boolean",
                "coreRequiredToVendor": "Boolean",
                "cost": "Decimal2",
                "daysToReturn": "UInt",
                "daysToReturnCore": "UInt",
                "daysToReturnCoreToVendor": "UInt",
                "daysToReturnToVendor": "UInt",
                "defaultVendorId": "UInt",
                "deplete": "Boolean",
                "description": "String",
                "distributorCorePrice": "Decimal2",
                "distributorPrice": "Decimal2",
                "freezeUntil": "Date",
                "glCategoryId": "Int",
                "id": "UInt",
                "interchangeNumber": "String",
                "jobberCorePrice": "Decimal2",
                "jobberPrice": "Decimal2",
                "listPrice": "Decimal2",
                "locations": "InventoryLocationUpdates",
                "manufacturerId": "UInt",
                "maxQuantity": "Decimal6",
                "minQuantity": "Decimal6",
                "modelId": "UInt",
                "notes": "String",
                "oemNumber": "String",
                "optionValues": "InventoryOptionValueUpdate",
                "parentManufacturerId": "UInt",
                "parentModelId": "UInt",
                "partNumber": "String",
                "popularityCode": "String",
                "printTag": "Boolean",
                "public": "Boolean",
                "purchaseFactor": "Boolean",
                "quantity": "Decimal6",
                "replenishable": "Boolean",
                "retailCorePrice": "Decimal2",
                "retailPrice": "Decimal2",
                "returnable": "Boolean",
                "returnableToVendor": "Boolean",
                "safetyStockPercent": "Decimal2",
                "saleClass": "SaleClassReference",
                "seasonal": "Boolean",
                "sellPackage": "Int",
                "sellPriceClassId": "Int",
                "serialized": "Boolean",
                "serials": "NestedInventorySerialUpdate",
                "shippingDimensions": "DimensionsInput",
                "side": "SideEnum",
                "singleQuantity": "Boolean",
                "status": "StatusEnum",
                "stockMethod": "StockMethodEnum",
                "stockType": "StockTypeEnum",
                "stockingDays": "Int",
                "subInterchangeNumber": "String",
                "tagNumber": "String",
                "taxable": "Boolean",
                "typeData1": "String",
                "typeData2": "String",
                "typeData3": "String",
                "typeData4": "String",
                "userStatus": "String",
                "vehicleId": "Int",
                "vehicleMake": "String",
                "vehicleModel": "String",
                "vehicleVin": "String",
                "vehicleYear": "UInt",
                "vendorPopularityCode": "String",
                "vendorProductCode": "String",
                "wholesaleCorePrice": "Decimal2",
                "wholesalePrice": "Decimal2"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=3e0a34637494e7bb8d5a1a2b10156af361c7e1b750c0e78ec200569921926afe";